import { DashboardTicket, DashboardTicketsMetaData } from 'Interfaces/Ticket/Ticket';

export interface TicketState {
    updatedTicketsBackup: DashboardTicket[];
    updatedTickets: DashboardTicket[];
    dashboardTicketsMetada: DashboardTicketsMetaData;
}

export interface TicketLocation {
    ticketId: string;
    reviewerId: string;
}

export const ticketInitialState: TicketState = {
    updatedTicketsBackup: [],
    updatedTickets: [],
    dashboardTicketsMetada: {
        currentStrength: '-',
        needFocus: '-',
        averageTicketsScore: 0,
        completedReviewsCounter: 0,
    },
};
